import React, { useCallback, useEffect, useState } from 'react';
import { Box, Flex } from "@chakra-ui/layout";
import { Image, Link } from "@chakra-ui/react";
import Call from "../../../images/class/call.svg";
import Video from "../../../images/class/video.svg";
import Mic from "../../../images/class/microphone.svg";
import { Iconly } from 'react-iconly';
import { useHistory } from "react-router-dom";
import Peer from 'peerjs';
import Swal from 'sweetalert2';
import socket from "../../../utilities/socket";
import { useSelector } from 'react-redux';
import { StateType } from '../../../store/store';
import { userType } from '../../../interfaces/interfaces';

export type Props = {
  peer: Peer,
  peers: any,
  userStream: MediaStream,
  aCall: Peer.MediaConnection | undefined,
  getPeerId: string,
  _class: string,
  sharingStatus: boolean,
  shareScreen(): Promise<void>,
  participantVideo: userType & { sharing: JSX.Element[] },
  participantReceiverVideo: userType,
  setParticipantVideo: React.Dispatch<React.SetStateAction<userType & { sharing: JSX.Element[] }>>
  setParticipantReceiverVideo: React.Dispatch<React.SetStateAction<userType>>
}

function Controls({ peer, userStream, aCall, peers, getPeerId, _class, sharingStatus, shareScreen, participantVideo, participantReceiverVideo, setParticipantVideo, setParticipantReceiverVideo }: Props) {
  let history = useHistory();
  const { studentReducer } = useSelector((state: StateType) => state.rootReducer);
  const userRole = studentReducer.data.role !== "" ? "student" : "tutor";

  const [micEnabled, setMicEnabled] = useState<boolean>(true);
  const [cameraEnabled, setCameraEnabled] = useState<boolean>(true);
  const [recordingStatus, setRecordingStatus] = useState<boolean>(false);
  const [downloadBtn, setDownloadBtn] = useState<boolean>(true);
  const [recordedData, setRecordedData] = useState<BlobPart[]>([]);

  useEffect(() => {
    console.log(participantVideo, participantReceiverVideo)
  }, [participantReceiverVideo, participantVideo])

  function leaveMeeting() {
    // stop the users media
    if (userStream) {
      userStream.getTracks().forEach(track => track.stop());
    }
    // stop the call
    if (aCall) {
      aCall.close();
    }
    console.log(peer.id)
    socket.disconnect();
    delete peers[peer.id];
    peer.destroy();
    history.push(`/${userRole}`);
  }

  function muteUnmute(stream: MediaStream) {
    console.log(micEnabled)
    if (micEnabled) {
      stream.getAudioTracks()[0].enabled = false;
      setMicEnabled(false)
    } else {
      stream.getAudioTracks()[0].enabled = true;
      setMicEnabled(true)
    }
  }

  function playStop(stream: MediaStream) {
    console.log(cameraEnabled)
    if (cameraEnabled) {
      stream.getVideoTracks()[0].enabled = false;
      setCameraEnabled(false)
    } else {
      stream.getVideoTracks()[0].enabled = true;
      setCameraEnabled(true)
    }
  }

  const options = {
    audioBitsPerSecond: 128000,
    videoBitsPerSecond: 2500000,
    mimeType: "video/webm"
  }
  const mediaRecorder = new MediaRecorder(userStream, options);

  function startRecording() {
    function handleDataAvailable(e: BlobEvent) {
      console.log("data available");
      console.log(userStream.getTracks())
      console.log(e.data)
      let chunks: BlobPart[] = [];
      if (e.data && e.data.size > 0) {
        chunks.push(e.data);
        setRecordedData(chunks)
        console.log(e.data)
      }
    }

    mediaRecorder.ondataavailable = handleDataAvailable;
    mediaRecorder.start();
    mediaRecorder.requestData();
    setRecordingStatus(true);
    setDownloadBtn(true);// set downloadBtn to disabled
  }

  function stopRecording() {
    mediaRecorder.stop();
    console.log(recordedData)
    setDownloadBtn(false)// enable download btn
    setRecordingStatus(false);
  }

  function downloadRecordedClass() {
    if (!recordingStatus && !downloadBtn) {
      const blobs = new Blob(recordedData, { type: "video/mp4" });
      const url = URL.createObjectURL(blobs);
      let download = document.createElement("a");
      document.body.appendChild(download);
      download.style.display = "none";
      download.href = url;
      download.download = `${_class}.webm`;
      download.click();
      setTimeout(() => {
        document.body.removeChild(download)
        window.URL.revokeObjectURL(url);
      }, 500)
    }
  }

  return (
    <Flex position={"fixed"} bottom={0} left={0} right={0} zIndex={"3"} bgColor={"gray.200"} boxShadow={"2xl"}
      justifyContent={"center"} alignItems={"center"} py={3} overflow={"auto"} pl={{ base: "130px", md: 0 }}>
      <Image
        boxSize="50px"
        objectFit="cover"
        mr={"12px"}
        src={Call}
        bgColor={"#EF4444"}
        borderRadius={"50%"}
        p={3}
        alt="call control"
        title={"Leave meeting"}
        onClick={() => leaveMeeting()}
      />
      <Link id={"downloadBtn"} disabled={downloadBtn} onClick={() => downloadRecordedClass()} borderRadius={"50%"}
        mr={"12px"} p={2.5}
        bgColor={"rgba(17, 24, 39, 0.5)"}>
        <Iconly label={"download class"} name={"Download"} set={"bold"} primaryColor="white" size="large" />
      </Link>
      <Box title="stop recording" bgColor="rgba(17, 24, 39, 0.5)" p={2.5} borderRadius={"50%"} mr={"12px"}>
        <Iconly label="stop recording" name="Video" set="bold" size="large"
          onClick={() => stopRecording()}
        />
      </Box>
      <Image
        boxSize="50px"
        objectFit="cover"
        mr={"12px"}
        src={Video}
        bgColor={`${recordingStatus ? "red.500" : "rgba(17, 24, 39, 0.5)"}`}
        borderRadius={"50%"}
        p={3}
        alt="record"
        title={"start recording"}
        onClick={() => startRecording()}
      />
      <Box title={"share screen"} bgColor={`${sharingStatus ? "red.500" : "rgba(17, 24, 39, 0.5)"}`} p={2.5}
        borderRadius={"50%"} mr={"12px"}>
        <Iconly label={"share screen"} name="Scan" set="bold" primaryColor="white" size="large"
          onClick={() => shareScreen()}
        />
      </Box>
      <Image
        title={"mute/unmute"}
        boxSize="50px"
        objectFit="cover"
        mr={"12px"}
        src={Mic}
        bgColor={`${micEnabled ? "rgba(17, 24, 39, 0.5)" : "red.500"}`}
        borderRadius={"50%"}
        p={3}
        alt="microphone"
        onClick={() => muteUnmute(userStream)}
      />
      <Box title={"show/off camera"} bgColor={`${cameraEnabled ? "rgba(17, 24, 39, 0.5)" : "red.500"}`} p={2.5}
        borderRadius={"50%"} mr={"12px"}>
        <Iconly label={"camera control"} name="Camera" set="bold" primaryColor="white" size="large"
          onClick={() => playStop(userStream)}
        />
      </Box>
    </Flex>
  )
}

export default Controls;